document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".impact-item");
  const bannerImage = document.getElementById("impact-banner-image");

  function updateBanner(item) {
    const desktopSrc = item.dataset.desktop;
    const mobileSrc = item.dataset.mobile;

    if (window.innerWidth <= 767 && mobileSrc) {
      bannerImage.src = mobileSrc;
    } else {
      bannerImage.src = desktopSrc;
    }
  }

  items.forEach((item) => {
    const summary = item.querySelector("summary");

    summary.addEventListener("click", function (e) {
      e.preventDefault();

      if (item.open) return;

      items.forEach((other) => {
        other.removeAttribute("open");
      });

      item.setAttribute("open", true);
      updateBanner(item);
    });
  });

  window.addEventListener("resize", function () {
    const activeItem = document.querySelector(".impact-item[open]");
    if (activeItem) {
      updateBanner(activeItem);
    }
  });
});